module.exports = __webpack_public_path__ + "img/gh-36006-3.prt.241fb876.jpg";